// ======================
// GSAP / Lenis（スムーススクロール）初期化
// ライブラリの読込失敗・競合で初期化に失敗しても、以降のUI（ハンバーガー等）まで
// 巻き添えで止まらないよう try/catch でガードする。
// （Lenis はグローバル漏れによる衝突対策として assets/ の IIFE 包み版を使用）
// ======================
let lenis = null;
try {
  if (window.gsap && window.ScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger);
  }
  if (window.Lenis) {
    lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      smoothTouch: false,
    });

    // 他スクリプト（LPのアンカースクロール等）から再利用できるよう公開
    window.lenis = lenis;

    if (window.ScrollTrigger) lenis.on("scroll", ScrollTrigger.update);

    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
  }
} catch (err) {
  console.error("[main.js] スムーススクロール初期化に失敗（以降のJSは継続します）:", err);
  lenis = null;
}

// ======================
// マルキー（全ページ共通・安全版）
// ======================
const textSlides = document.querySelectorAll(".text-slide");

if (window.gsap && textSlides.length) {
  const allTweens = [];

  textSlides.forEach((slide) => {
    const track = slide.querySelector(".marquee-track");

    // DOM構造チェック
    if (!track || !track.firstElementChild) return;

    // === コンテンツ複製関数（安全版） ===
    function fillTrack() {
      // trackの子要素が存在しない場合は中断
      if (track.children.length === 0) return;

      // 初期幅が0（非表示）なら強制的に1ループで抜ける
      let safety = 0;
      while (track.scrollWidth < slide.clientWidth * 2 && safety < 20) {
        track.appendChild(track.firstElementChild.cloneNode(true));
        safety++;
      }
    }
    fillTrack();

    const loopDistance = track.scrollWidth / 2;

    // scrollWidthがゼロの場合はアニメーション無効化
    if (loopDistance <= 0) return;

    // 無限ループアニメーション
    const tween = gsap.to(track, {
      x: -loopDistance,
      ease: "none",
      duration: 40,
      repeat: -1,
      modifiers: {
        x: (x) => {
          const v = parseFloat(x);
          return ((v % -loopDistance) + "px");
        },
      },
    });

    allTweens.push(tween);
  });

  // スクロール速度連動（Lenis 有効時のみ）
  if (lenis) {
    lenis.on("scroll", ({ velocity }) => {
      const speed = gsap.utils.clamp(0.2, 3.5, 1 + velocity / 300);
      allTweens.forEach((t) => t.timeScale(speed));
    });
  }
}

// ======================
// ヘッダー制御（共通）
// ======================
$(function () {
  $(".hum").click(function () {
    $("header").toggleClass("hum-open");
    $(".hum").toggleClass("active");
    $(".header_contents").toggleClass("active");
  });

  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 600) {
      $("header").addClass("scrolled");
    } else {
      $("header").removeClass("scrolled");
    }
  });
});

$(function() {
  $('a[href^="#"]').click(function(e) {
    e.preventDefault();

    const href = $(this).attr('href');
    const isTop = (href === '#' || href === '');
    const $target = $(isTop ? 'html' : href);
    if (!$target.length) return;

    const headerHeight = $('header').outerHeight() || 0;

    // Lenis 有効時はネイティブの scrollTop アニメーションと競合して
    // スクロールが途中で止まる／カクつくため、lenis.scrollTo に委譲する。
    // offset は正値で「さらに下」なので、上に余白を空けるには負値を渡す。
    if (window.lenis && typeof window.lenis.scrollTo === 'function') {
      window.lenis.scrollTo(isTop ? 0 : $target.get(0), {
        offset: -headerHeight,
        duration: 1.1,
      });
    } else {
      // フォールバック（Lenis 未使用時）
      const position = $target.offset().top - headerHeight;
      $('html, body').animate({ scrollTop: position }, 600, 'swing');
    }
  });
});